"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuPanel = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const Panels_1 = require("./Panels");
const lib_1 = require("../lib");
const MenuPanelGrid = (0, app_1.styled)(ui_1.Grid) `
  min-height: 100%;
  @media ${app_1.mobile} {
    grid-template-columns: 1fr;
  }
  > div:not(:last-of-type) {
    border-right: 1px solid ${(theme) => theme.stroke};
  }
`;
const ExitButton = (0, app_1.styled)(ui_1.Button) `
  position: absolute;
  top: ${(theme) => theme.spacing.extraSmall};
  right: ${(theme) => theme.spacing.extraSmall};
`;
const drawerStyle = (0, app_1.css) `
  max-width: 100vw;
  width: 100vw;
  background: ${(theme) => theme.background};
`;
function MenuPanel({ panels, menu = 'menuPanelOpen', }) {
    const [uiState, dispatch] = (0, lib_1.useUi)(menu);
    const { asPath } = (0, app_1.useRouter)();
    (0, react_1.useEffect)(() => {
        dispatch('CLOSE_ALL_PANELS');
    }, [dispatch, asPath]);
    if (!uiState[menu]) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(ui_1.Drawer, Object.assign({ noMaxWidth: true, contentStyle: drawerStyle }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MenuPanelGrid, Object.assign({ templateColumns: "repeat(3, minmax(0,1fr))" }, { children: panels })), (0, jsx_runtime_1.jsx)(ExitButton, Object.assign({ kind: ['icon', 'transparent'], onClick: () => dispatch('CLOSE_ALL_PANELS') }, { children: (0, jsx_runtime_1.jsx)(svg_1.SvgCloseMenu, {}) }))] }) })));
}
exports.MenuPanel = MenuPanel;
MenuPanel.Event = Panels_1.Event;
MenuPanel.Socials = Panels_1.Socials;
MenuPanel.Links = Panels_1.Links;
